module.exports = __webpack_public_path__ + "img/rede-2025-03.d78af99f.jpg";